module.exports = __webpack_public_path__ + "img/photo_2022-11-07_21-45-46.424952ce.jpg";